import React, { useEffect, useState } from "react";

const targetTime = new Date(Date.now() + 10000);
// const targetTime = new Date(Date.now() + 5 * 60 * 1000);

export const Countdown = () => {
  const [currentTime, setCurrentTime] = useState(Date.now());

  const timeBetween = targetTime - currentTime;
  const seconds = Math.floor((timeBetween / 1000) % 60);
  const minutes = Math.floor((timeBetween / 1000 / 60) % 60);
  const hours = Math.floor((timeBetween / (1000 * 60 * 60)) % 24);
  const days = Math.floor(timeBetween / (1000 * 60 * 60 * 24));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const checkCompleted = () => {
    if (timeBetween < 1000) {
      console.log("Completed");
    }
  };

  return (
    <>
      <p>Deadline comes in</p>
      <p className="counter">
        {/* <span>{days}d </span>
        <span>{hours}h </span> */}
        <span>{minutes}min </span>
        <span>{seconds}s</span>
      </p>
    </>
  );
};
